import { z } from "zod";
import { UserRole, UserStatus } from "../enums.js";
import { emailSchema, mobilePhoneSchema } from "./common.js";
export const userSettingsSchema = z.object({
    pushEnabled: z.boolean().optional(),
    emailNotificationsEnabled: z.boolean().optional(),
    mobilePhone: mobilePhoneSchema,
});
export const featureSuggestionSchema = z.object({
    description: z.string().trim().min(5, "Bitte mindestens 5 Zeichen").max(4000),
});
export const createInvitationSchema = z.object({
    email: emailSchema,
});
export const adminUpdateUserSchema = z.object({
    role: z.nativeEnum(UserRole).optional(),
    status: z.nativeEnum(UserStatus).optional(),
});
export const csvImportRowSchema = z.object({
    firstName: z.string().trim().min(1),
    lastName: z.string().trim().min(1),
    email: emailSchema,
});
export const adminUsersQuerySchema = z.object({
    status: z.nativeEnum(UserStatus).optional(),
    role: z.nativeEnum(UserRole).optional(),
    search: z.string().trim().max(120).optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=user.js.map